import { gql } from 'graphql-tag'

export default gql`
  query SearchFacetOptions(
    $id: String!
    $categoryPath: [String!]!
    $search: String!
    $filter: MarketplaceProductsFilter
    $query: String
  ) {
    facet: marketplaceProductFacet(
      id: $id
      categoryPath: $categoryPath
      filter: $filter
      query: $query
    ) {
      id
      searchFieldPlaceholder
      title
      type
      options(search: $search) {
        label
        group
        id
      }
    }
  }
`
